export default __webpack_public_path__ + "static/Resource-Efficiency-00eac93072ca85fe6fa02d87e61c3bf1.webp";